
import MvpLogo from '../assets/images/mvp-logo.svg';
import RightSideBarImg from '../assets/images/rightPanelImg.svg';
import RightSideBarImgMdLg from '../assets/images/rightPanelImgMdLg.svg';
import MySelf from '../assets/images/mySelf.svg';
import FamilyViewLeft from '../assets/images/familyViewLeft.svg';
import FamilyViewMiddle from '../assets/images/familyViewMiddle.svg';
import FamilyViewRight from '../assets/images/familyViewRight.svg';
import FamilyViewMiddleBlack from '../assets/images/familyViewMiddleBlack.svg';
import FamilyViewRightGrey from '../assets/images/familyViewRightGrey.svg';
import Chatbot from '../assets/images/chatbot.svg';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import BackIcon from '../assets/images/back.svg';
import CheckCircle from '../assets/images/check-circle.svg';
import FamilyDuotone3 from '../assets/images/familyDuotone3.svg';
import FamilyDuotone3a from '../assets/images/familyDuotone3a.svg';
import EyeIcon from '../assets/images/eye.png';
import EligibilityXL from '../assets/images/eligibilityXL.svg';
import SubInfoXL from '../assets/images/SubInfoXL.svg';
import DependentInfoXL from '../assets/images/DependentInfoXL.svg'
import ReviewXL from '../assets/images/ReviewXL.svg';
import ThankyouXL from '../assets/images/thankyouXL.svg';

const Icons = {
    MvpLogo,
    RightSideBarImg,
    RightSideBarImgMdLg,
    MySelf,
    FamilyViewLeft,
    FamilyViewMiddle,
    FamilyViewRight,
    FamilyViewMiddleBlack,
    FamilyViewRightGrey,
    Chatbot,
    InfoIcon,
    BackIcon,
    CheckCircle,
    FamilyDuotone3,
    FamilyDuotone3a,
    EyeIcon,
    EligibilityXL,
    SubInfoXL,
    DependentInfoXL,
    ReviewXL,
    ThankyouXL
}

export default Icons